import { Controller } from "@hotwired/stimulus";

export class PasswordToggleController extends Controller {
 static targets = ["input", "button"];

  toggle() {
    const isHidden = this.inputTarget.type === "password";
    this.inputTarget.type = isHidden ? "text" : "password";

    this.buttonTarget.classList.toggle("is-on", isHidden);
    this.buttonTarget.setAttribute("aria-pressed", String(isHidden));
    this.buttonTarget.setAttribute(
      "aria-label",
      isHidden ? "Ocultar contraseña" : "Mostrar contraseña"
    );
  }
}
